/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

// Wrapper component to prevent propagation of events to parent elements
const StopPropagationWrapper = ({ children }: { children: React.ReactElement }) => {
  return (
    <span
      role="presentation"
      css={css`
        display: inline-flex;
        gap: var(--cds-spacing-100);
      `}
      onClick={(event: React.MouseEvent<HTMLSpanElement>) => {
        event.stopPropagation();
      }}
      onKeyDown={(event: React.KeyboardEvent<HTMLSpanElement>) => {
        // Only stop propagation for activation keys
        if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
          event.stopPropagation();
        }
      }}
    >
      {children}
    </span>
  );
};

export default StopPropagationWrapper;
